import type { PersonalFeatures } from './types/configurationFlags';

export const CONFIGURATION_FLAGS: PersonalFeatures = {
  planFinder: true,
  planComparison: true,
  addons: true,
};
